import { UtenteDTO } from "./utenteDTO";

export class AnagraficaCampoSpecificoDTO {
  id: string;
  nomeCampo: string;
  tipoCampo: string;
  valori: string[];
  dataCreazione: string;
  dataModifica: string;
  operatore: UtenteDTO;
}
